import { useNavigate } from '@integrations/routing'
import { REFER_AND_EARN_BANNER_DISMISSED_HINT_KEY, REFER_AND_EARN_LINK_COPIED_HINT_KEY } from '@referAndEarn/constants'
import { uiSize } from '@utils'
import { paths, useMerchantQry, useReferralStatisticsQry, useUserHintsQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import type { PromoItem } from './PromoBanner'

function GiftIcon() {
  return (
    <svg width={uiSize(24)} height={uiSize(24)} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7s-1.5-5-4.5-5C5 2 4 3.5 4 4.5 4 6.5 7 7 12 7zM12 7s1.5-5 4.5-5C19 2 20 3.5 20 4.5 20 6.5 17 7 12 7z' />
    </svg>
  )
}

export function useReferralPromo(): PromoItem | null {
  const navigate = useNavigate()

  const { merchant } = useMerchantQry()
  const allowReferrals = Boolean(merchant?.capabilities?.allowReferrals)

  const { statistics, statisticsError, statisticsLoading } = useReferralStatisticsQry()
  const { isHintSeen, hintsFetching, saveHintSeen } = useUserHintsQry()

  const dismissed = isHintSeen(REFER_AND_EARN_BANNER_DISMISSED_HINT_KEY)
  const alreadyCopied = isHintSeen(REFER_AND_EARN_LINK_COPIED_HINT_KEY)

  function handleDismiss() {
    saveHintSeen(REFER_AND_EARN_BANNER_DISMISSED_HINT_KEY)
  }

  function handleGetLink() {
    navigate(paths.referralProgram())
  }

  if (
    !allowReferrals ||
    statisticsLoading ||
    statistics?.enabled === false ||
    statisticsError ||
    hintsFetching ||
    dismissed ||
    alreadyCopied
  ) {
    return null
  }

  return {
    id: 'refer-and-earn-banner',
    tone: 'action',
    icon: <GiftIcon />,
    title: tr('FRONTEND.DASHBOARD.REFER_BANNER.HEADING', 'New: Refer & Earn.'),
    text: tr(
      'FRONTEND.DASHBOARD.REFER_BANNER.TEXT',
      'Get a commission on the processing fees from every business you bring to banky.'
    ),
    ctaLabel: tr('FRONTEND.DASHBOARD.REFER_BANNER.CTA', 'Get your link'),
    ctaTestId: 'refer-and-earn-banner-cta',
    dismissTestId: 'refer-and-earn-banner-dismiss',
    onCta: handleGetLink,
    onDismiss: handleDismiss
  }
}
